export const LOAD_CHANNEL_CATEGORIES_INIT = 'LOAD_CHANNEL_CATEGORIES_INIT';
export const LOAD_CHANNEL_CATEGORIES_SUCCESS = 'LOAD_CHANNEL_CATEGORIES_SUCCESS';
export const LOAD_CHANNEL_CATEGORIES_ERROR = 'LOAD_CHANNEL_CATEGORIES_ERROR';
export const TOGGLE_SHOW_CATEGORIES = 'TOGGLE_SHOW_CATEGORIES';
